import { faArrowsRotate, faCheck, faExclamation, faGear } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import SubscriptionCard from './SubscriptionCard'
import { ProfileVM } from '../../Structure/ViewModels/Trainee/ProfileVM'
import CertifiesCard from './CertifiesCard'
import { Router } from '../../Structure/Handlers/Router'
import ClientSubscribe from '../Management/ClientSubscribe'
import EditClientInfo from './EditClientInfo'
import { Globals } from '../../Structure/Globals/GlobalObs'
import { bePath, mainPath } from '../../Structure/Constants/MainPath'
import { GeneralMethods } from '../../Structure/Handlers/GeneralMethods'


const Profile = (props:{id:string}) => {
    const [vm, setVm] = useState<{viewModel:ProfileVM}>({viewModel:new ProfileVM(props.id)})
    const control = vm.viewModel
    useEffect(()=>{ 
        control.subscribeUpdate(setVm) 
        control.getProfile()
    }, [])
    useEffect(()=>{
        if(control.Loaded){
            control.Loaded = false
            control.getProfile()
        }
    },[control.Loaded])

    const Img = (props:{img:string})=>{
        const type = GeneralMethods.isImageOrPdf(props.img)
        if(type){
            if(type === 'pdf')return(<div className='w-100' onClick={()=>window.open(`${bePath}/storage/uploads/images/ids/${props.img}`)}>مشاهدة الملف</div>)
            else if(type=== 'img')return(
                <div className='txt-color-I w-100' onClick={()=>window.open(`${bePath}/storage/uploads/images/ids/${props.img}`)}>
                    <img style={{height:'50px' , maxWidth:'100px'}} src={`${bePath}/storage/uploads/images/ids/${props.img}`} alt="" />
                </div>
            )
            else return (<div></div>)
        } else return (<div></div>)
    }


  return (
    <Container>
        {
            control.Show(
        <div className='py-5'>
            <h1 className='txt-color-I fw-bold py-2'>
                {
                    control.Data?.personal_info.arabic_name
                }
                <sub className='px-3 fw-normal fs-3'>({control.Data?.personal_info.english_name})</sub>   
            </h1>
            <div className='d-flex'>
                <div className='bill bill-II'>{control.Data?.personal_info.marketer}</div>
            </div>

                <div className='d-flex flex-wrap'>
                    {
                        Globals.auth.User?.permissions.some(a=>a.id=='2')?(
                            <div className='p-2'>
                                <button className='button-I btn-cl-I px-3 py-1' onClick={()=>Router.OpenNormalPage(<EditClientInfo id={props.id}/>)}>تعديل البيانات الشخصية</button>
                            </div>
                        ):(null)
                    }
                    {
                        Globals.auth.User?.permissions.some(a=>a.id=='3')?(
                            <div className='p-2'>
                                <button className='button-I btn-cl-I px-3 py-1' onClick={()=>Router.OpenNormalPage(<ClientSubscribe id={props.id} name={control.Data?.personal_info.arabic_name||''}/>)}>اضافة اشتراك</button>
                            </div>
                        ):(null)
                    }
                    {
                        Globals.auth.User?.permissions.some(a=>a.id=='26')?(
                            <div className='p-2'>
                                <button className='button-I btn-cl-I px-3 py-1' onClick={()=>{control.HasNew = !control.HasNew}}>{control.HasNew?('الغاء'):('اضافة شحنة')}</button>
                            </div>
                        ):(null)
                    }
                                        {
                        Globals.auth.User?.permissions.some(a=>a.id=='26')?(
                            control.Data?.subscriptions_data.length == 0 || control.Data?.subscriptions_data.filter(a=>a.levels.filter(b=>b.subscription?(b.subscription.transactions.length!=0):false).length!=0).length==0?(
                            <div className='p-2'>
                                <button className='button-I btn-cl-I px-3 py-1 bg-danger' onClick={()=>{ control.deleteTrainee() }}>حذف العميل</button>
                            </div>
                            ):(
                                null
                            )
                        ):(null)
                    }
                </div>    
            {
            Globals.auth.User?.permissions.some(a=>a.id=='26')?(control.HasNew?(
            <Row className='py-4'>
                <Col md={4}>
                    <div className='d-flex flex-column justify-content-center h-100'>
                        <input type="text" className='input-field h-100' value={control.ShippingData.number} onChange={a=>control.ShippingNumber = a.target.value} placeholder='رقم الشحنة' />
                        <div className='d-flex py-3 h-100'>
                            <input id='shipping-status' className='my-auto' type="checkbox" checked={control.ShippingData.status} onChange={a=>control.ShippingStatus = a.target.checked} />
                            <label htmlFor="shipping" className='px-3 my-auto'>تم تسليم الشحنة ؟</label>
                        </div>
                    </div>
                </Col>
                <Col md={4}>
                    <div className='d-flex flex-column justify-content-center h-100'>
                        <textarea className='input-field h-100' style={{resize:'none'}}  value={control.ShippingData.notes} onChange={a=>control.ShippingNotes = a.target.value} placeholder='ملاحظات' />
                    </div>
                </Col>
                <Col md={4}>
                    <div className='h-100 d-flex justify-content-center'>
                        <button className='button-I btn-cl-I my-auto px-5 py-2' onClick={()=>control.sendShipping()}>اضافة</button>
                    </div>
                </Col>
            </Row>):(null)):(null)
            }
            <Row className='border mt-5 text-end'>
                <Col md={6} className='py-3'>
                    <div className='w-100 d-flex justify-content-start'>
                        <div className='w-100'>
                            ايميل
                        </div>
                        <div className='txt-color-I w-100'>
                            {control.Data?.personal_info.email}
                        </div>
                    </div>
                </Col>
                <Col md={6} className='py-3'>
                    <div className='w-100 d-flex justify-content-start'>
                        <div className='w-100'>
                            الجنسية
                        </div>
                        <div className='txt-color-I w-100'>
                            {control.Data?.personal_info.nationality}
                        </div>
                    </div>
                </Col>
                {
                Globals.auth.User?.permissions.some(a=>a.id=='21')?(
                    <Col md={6} className='py-3'>
                        <div className='w-100 d-flex justify-content-start'>
                            <div className='w-100'>
                                موبايل
                            </div>
                            <div className='txt-color-I w-100'>
                                {control.Data?.personal_info.mobile}
                            </div>
                        </div>
                    </Col>
                    ):(null)
                }
                {
                Globals.auth.User?.permissions.some(a=>a.id=='21')?(
                <Col md={6} className='py-3'>
                    <div className='w-100 d-flex justify-content-start'>
                        <div className='w-100'>
                            العنوان
                        </div>
                        <div className='txt-color-I w-100'>
                            {control.Data?.personal_info.address} 
                        </div>
                    </div>
                </Col>
                ):(null)
                }
                <Col md={6} className='py-3'>
                    <div className='w-100 d-flex justify-content-start'>
                        <div className='w-100'>
                            تاريخ الميلاد
                        </div>
                        <div className='txt-color-I w-100'>
                            {control.Data?.personal_info.birth_date}
                        </div>
                    </div>
                </Col>

                {
                    Globals.auth.User?.permissions.some(a=>a.id=='21')?(
                    control.Data?.personal_info.national_id?(
                        <Col md={6} className='py-3'>
                            <div className='w-100 d-flex justify-content-start'>
                                <div className='w-100'>
                                    رقم الهوية
                                </div>
                                <div className='txt-color-I w-100'>
                                    {control.Data?.personal_info.national_id}
                                </div>
                            </div>
                        </Col>
                    ):(null)):(null)
                }

                        <Col md={6} className='py-3'>
                            <div className='w-100 d-flex justify-content-start'>
                                <div className='w-100'>
                                    النوع
                                </div>
                                <div className='txt-color-I w-100'>
                                    {control.Data?.personal_info.is_male?'ذكر':'انثى'}
                                </div>
                            </div>
                        </Col>

                
                                {
                    Globals.auth.User?.permissions.some(a=>a.id=='21')?(
                    control.Data?.personal_info.national_id_img?(
                        <Col md={6} className='py-3'>
                            <div className='w-100 d-flex justify-content-start'>
                                <div className='w-100'>
                                    صورة الهوية
                                </div>
                                <Img  img={control.Data.personal_info.national_id_img}></Img>
                            </div>
                        </Col>
                    ):(null)):(null)
                }
            </Row>
            {
                Globals.auth.User?.permissions.some(a=>a.id=='21')?(
            <div className=' py-5'>
                <h3>الشحنات</h3>
                <div className='d-flex flex-wrap py-3'>
                {
                    control.Data?.shipment.map((item,index)=>
                    {
                        const Result= ()=>{
                            const [deleting , setDeleting] = useState<boolean>(false)
                            return(
                            deleting?(
                                <div>
                                    <div>هل تريد حذف الشحنة؟</div>
                                    <div className='d-flex justify-content-center'>
                                        <div className='material-symbols-outlined' onClick={()=>{setDeleting(false);control.deleteShipping(item.id)}}>check</div>
                                        <div className='material-symbols-outlined' onClick={()=>setDeleting(false)}>close</div>
                                    </div>
                                </div>
                            ):(
                            <div className='m-1 p-2 border rounded-3 px-3'>
                                <div className='d-flex justify-content-between'>
                                    <h5>{item.shipment_number}</h5>
                                    {
                                        Globals.auth.User?.permissions.some(a=>a.id=='26')?(
                                            <div className='material-symbols-outlined fw-normal' style={{color:'rgba(150,150,150)'}} onClick={()=>setDeleting(true)}>delete</div>
                                        ):(null)
                                    }
                                </div>

                                <div className='pb-3'>{item.notes}</div>
                                {
                                    Globals.auth.User?.permissions.some(a=>a.id=='26')?(item.status =='done'?(<h6>تم التسليم</h6>):(<button className='button-II btn-cl-I px-3 py-1' onClick={()=>control.activateShipping(item.id)}> اتمام</button>)):(null)
                                }
                            </div>))
                        }

                        return(<Result key={index} />)
                    })
                }
                </div>
            </div>):(null)
            }
            <h3 className='py-5'>الاشتراكات</h3>
            {
                control.Data?.subscriptions_data.map((item , index)=>(
                    <SubscriptionCard key={index} data={item} vm={control} id={props.id} name={control.Data?.personal_info.arabic_name||''} accounts={control.Data?.accounts??[]}/>
                ))
            }
            {
                Globals.auth.User?.permissions.some(a=>a.id=='18')?(<h3 className='py-5 pb-3'>الدورات المنتهية</h3>):(null)
            }
            {
                Globals.auth.User?.permissions.some(a=>a.id=='18')?(control.Data?.certifies.map((item , index)=>(
                    <CertifiesCard key={index} data={item} id={props.id} name={control.Data?.personal_info.arabic_name||''}/>
                ))):(null)
            }
        </div>)
        }
    </Container>
  )
}

export default Profile
